module.exports = __webpack_public_path__ + "img/icon_dayan_normal@2x.06529f69.png";